import React, { useState } from 'react'

const ReceiptNotMatchModal = ({handleSave}) => {

  const [note, setNote] = useState('')

  const handleConfirm = () => {
    handleSave(note)
  }

  return (
    <div className="bg-white-100 p-5 rounded-lg shadow-xl">
      <h2 className="text-lg mb-4 b">ยอดไม่ตรงกับสลิป</h2>
      <input
        className="border border-gray-300 p-2 w-full mb-4"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="หมายเหตุ..."
      />
      <div className="flex justify-end">
        <button 
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={handleConfirm}
        >
          Update
        </button>
      </div>
    </div>
  )
}

export default ReceiptNotMatchModal